const css = `.aSK17q__NotificationPopover{border:2px solid var(--base-strokes-elevation-high);border-radius:4px}.aSK17q__NotificationPopover>div:first-child{border:none}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"NotificationPopover":"aSK17q__NotificationPopover"};
